import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CustomFormsModule} from 'ng2-validation';
import {PipeModule} from '../../pipe/pipe.module';
import {AddressComponent} from './address.component';

@NgModule({
  imports: [CommonModule, CustomFormsModule, FormsModule, PipeModule],
  declarations: [AddressComponent],
  exports: [AddressComponent],
})
export class AddressModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/address/address.module.ts